import { Component, OnInit } from '@angular/core';
import * as Highcharts from 'highcharts';
import { HighChartsFactory } from '../highcharts.factory';
import { DashboardService } from 'src/app/shared/api/services/dashboard.service';
import { SeriesPieOptions } from 'highcharts';

@Component({
  selector: 'dash-item-tract',
  templateUrl: './dash-item-tract.component.html',
  styleUrls: ['./dash-item-tract.component.scss']
})
export class DashItemTractComponent implements OnInit {

  public Highcharts: typeof Highcharts = Highcharts;
  public chartOptions: Highcharts.Options;
  public lastUpdated = "--";
  public total : String | number = "--";
  constructor(private dashboardService: DashboardService){}

  async ngOnInit() {
    try {
      var resp = await this.dashboardService.GetClientMonthlyStatusData().toPromise();
      this.lastUpdated = resp.timestamp;
      this.total = resp.manualEventsTotal + resp.aggregationEventsTotal;
      var tractData: SeriesPieOptions["data"] = [
        {
          name: 'Manuals',
          y: resp.manualEventsTotal
        },
        {
          name: 'Aggregations',
          y: resp.aggregationEventsTotal
        }
      ]; // resp.data
      this.chartOptions = HighChartsFactory.createPieChartOptions(tractData);
    }
    catch(e)
    {
      this.total = "Error Loading";
      console.log(e);
    }
  }

}
